import { Checkbox, CheckboxChangeEvent, Flex } from 'antd';
import { format, isToday } from 'date-fns';
import { memo, useCallback, useMemo } from 'react';

import { transformMessagePreview } from '../../transform-message';

interface MessageTabProps {
  title: string;
  read?: boolean;
  active?: boolean;
  message: string;
  onClick: () => void;
  created: Date;
  modified: Date | null | undefined;
  checked: boolean;
  handleSelect: (checked: boolean) => void;
}

function MessageTab({
  title,
  read = false,
  active = false,
  message,
  onClick,
  created,
  modified,
  checked,
  handleSelect,
}: MessageTabProps) {
  const messageDate = useMemo(
    () => new Date(modified ?? created),
    [created, modified],
  );
  const isMessageToday = useMemo(() => isToday(messageDate), [messageDate]);
  const formattedTime = useMemo(
    () => format(messageDate, 'h:mm a'),
    [messageDate],
  );
  const formattedDate = useMemo(() => format(messageDate, 'PP'), [messageDate]);

  const containerClasses = useMemo(() => {
    const classes = ['message-list-item'];
    if (read) classes.push('read');
    if (active) classes.push('active');
    return classes.join(' ');
  }, [read, active]);

  const previewText = useMemo(
    () => transformMessagePreview(message),
    [message],
  );

  const handleCheckboxChange = useCallback(
    (e: CheckboxChangeEvent) => handleSelect(e.target.checked),
    [handleSelect],
  );

  const renderTimeSection = () => {
    if (isMessageToday) {
      return (
        <>
          {!read && <span className="new message-name-mobile">NEW</span>}
          <div className="from__time message-name-mobile">{formattedTime}</div>
        </>
      );
    }
    return <div className="from__time">{formattedDate}</div>;
  };

  return (
    <Flex className={containerClasses}>
      <div className="message-list-item__indicator">
        <Checkbox
          checked={checked}
          onChange={handleCheckboxChange}
          aria-label={`Select message from ${title}`}
        />
      </div>
      <Flex vertical className="message-list-item__details" onClick={onClick}>
        <Flex
          align="center"
          justify="space-between"
          className="from open-message-mobile"
        >
          <div className="from__name fw-bold message-name-mobile">{title}</div>
          {renderTimeSection()}
        </Flex>
        <div className="desc message-box-img">{previewText}</div>
      </Flex>
    </Flex>
  );
}

export default memo(MessageTab);
export { MessageTab };
